import React, { useEffect, useRef, useState } from 'react';
import {useDraggable} from "react-use-draggable-scroll";
import { ChevronLeft, ChevronRight, Search } from '@mui/icons-material';
import ICategory from '../interfaces/ICategory';
import useCheckMobileScreen from '../utils/detect-mobile-size';
import { IconButton } from '@mui/material';

export default function Categories(props: { activeId: any; setShowSearchBar: any; categories: ICategory[] }) {
    const setShowSearchBar = props.setShowSearchBar;
    const categories = props.categories;
    let activeId = props.activeId;
    let isMobile = useCheckMobileScreen();
    const [showScrollButtonLeft, setShowScrollButtonLeft] = useState(true);
    const [showScrollButtonRight, setShowScrollButtonRight] = useState(true);

    const ref = useRef();
    // @ts-ignore
    const { events } = useDraggable(ref);

    // TODO en onderstaand ding minder hacky maken lol
    const scroll = (scrollOffset: number) => {
        // @ts-ignore
        ref.current.style.scrollBehavior = 'smooth';
        // @ts-ignore
        ref.current.scrollLeft += scrollOffset;
        // @ts-ignore
        ref.current.style.scrollBehavior = 'auto';
    };

    useEffect(() => {
        // @ts-ignore
        if (ref.current.scrollLeft === 0) {
            setShowScrollButtonLeft(false);
        }

        activeId = activeId.replace('category_', '');

        const element = document.getElementById('item_' + activeId);
        const categorySelector = document.getElementById('category-selector');

        if (categorySelector && element) {
            categorySelector.style.scrollBehavior = 'smooth';
            categorySelector.scrollLeft = element.offsetLeft - 100;

            categorySelector.style.scrollBehavior = 'auto';
        }

    }, [activeId])

    const checkScrollPosition = () => {
        // @ts-ignore
        if (ref.current.scrollLeft < 20) {
            setShowScrollButtonLeft(false);
        } else {
            setShowScrollButtonLeft(true);
        }
        // @ts-ignore
        if (ref.current.offsetWidth + ref.current.scrollLeft >= ref.current.scrollWidth - 1) {
            setShowScrollButtonRight(false);
        } else {
            setShowScrollButtonRight(true);
        }
    }

    const changeCategoryPosition = (e: any, category: ICategory) => {
        const element = document.getElementById('item_' + category.id);
        // @ts-ignore
        element.parentElement.scrollLeft = element.offsetLeft - 100;
    }

    return (
        <div className="relative flex">
            <IconButton
                className="search-button category-selector-button"
                onClick={() => setShowSearchBar(true)}>
                <Search className="mx-1.5" />
            </IconButton>
            {showScrollButtonLeft && !isMobile &&
                <IconButton
                    onClick={() => scroll(-160)}>
                    <ChevronLeft />
                </IconButton>
            }
            {/*// @ts-ignore*/}
            <div onScroll={checkScrollPosition} id="category-selector" className="category-selector-inner" {...events} ref={ref}>
                {/*// @ts-ignore*/}
                {categories.map((cat) => <a onClick={(e) => changeCategoryPosition(e, cat)} id={'item_' + cat.id} className={activeId === "category_" + cat.id ? 'category-selected' : ''} key={cat.id} href={'#category_' + cat.id}>{cat.name}</a> )}
            </div>
            {showScrollButtonRight && !isMobile &&
                <IconButton
                    onClick={() => scroll(160)}>
                    <ChevronRight />
                </IconButton>
            }
        </div>
    )
}